// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2LRAh","requiredAsterisk":"Info_requiredAsterisk__SC8Zv"};